import styled from 'styled-components';
export const List = styled.div `
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.typography.textMedium};
  min-width: 200px;
`;
export const ListItem = styled.div `
  padding: 8px 16px;
  max-width: 240px;
  white-space: normal;
  word-break: break-word;
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey05_1};
  }
`;
export const Wrapper = styled.div `
  display: flex;
  gap: 4px;
  white-space: nowrap;
  align-items: center;
`;
